import { v4 } from 'uuid'
import { saveAs } from 'file-saver'

import { useRef } from 'react'
import { useRequest, useReactive } from 'ahooks'

import { Upload, Button, Tag, Col } from 'antd'
import { ProFormItem } from '@ant-design/pro-form'

function UploadButton(props) {
  let count = 1

  const {
      value = []
    , hint = '选择文件'
    , max = 6
    , upload
    , accept
    , readonly
    , onSave
    , onChange } = props

  const res = useRequest(async data => {
    const result = await Promise.all(data.map(upload)).then(urls => urls.map((url, index) => {
      return {
          url
        , filename: data[index].name
      }
    }))

    if (onSave) {
      await onSave(R.defaultTo([], value).concat(result))
    }

    return R.defaultTo([], value).concat(result)
  }, {
    manual: true,
  })

  const handleDelete = useRequest(data => {
    if (onSave) {
      return onSave(value?.filter(e => e.url != data.url)).then(() => onChange(value?.filter(e => e.url != data.url)))
    }

    else {
      return onChange(value?.filter(e => e.url != data.url))
    }
  }, {
    manual: true,
  })

  if ((R.isNil(value) || R.isEmpty(value)) && readonly) {
    return <div className='text-gray-500'>（暂无文件）</div>
  }

  return <div>
    {(value?.length >= max || readonly) ? null : (
      <>
        <Upload
          multiple
          maxCount={max}
          accept={accept}
          showUploadList={false}
          customRequest={() => Promise.resolve()}
          beforeUpload={(_, files) => {
            if (count >= files.length) {
              res.runAsync(files).then(onChange).finally(() => count = 1)
            }

            else {
              count++;
            }
          }}
        >
          <Button
            loading={res.loading}
            className='mb-2'
            icon={<i className='fa fa-upload mr-2 text-sm'/>}
          >
            {res.loading ? '上传中...' : hint}
          </Button>
        </Upload>

        {R.isNil(value) || R.isEmpty(value) ? null : (
          <div className='border-b border-dotted border-gray-200 mb-2'/>
        )}
      </>
    )}

    <div className='flex flex-wrap items-center'>
      {value?.map(elm => {
        return <Tag
          key={elm.url}
          color='geekblue'
          closable={!readonly}
          className='cursor-pointer min-w-[100px] text-center'
          style={{ margin: `0 6px 6px 0` }}
          title='点击下载'
          onClose={() => handleDelete.run(elm)}
          onClick={() => saveAs(elm.url, elm.filename)}
        >
          {elm.filename.length < 16 ? elm.filename : elm.filename.slice(0, 10) + '...'}
        </Tag>
      })}
    </div>
  </div>
}

export default function (props) {
  if (props.colProps) {
    return <Col span={props.colProps}>
      <ProFormItem {...R.omit([ 'help', 'colProps', 'fieldProps' ], props)} label={`${props.label}（点击已上传的文件可以下载）`}>
        <UploadButton {...R.omit([ 'onChange' ], props)} {...props.fieldProps} />
      </ProFormItem>
    </Col>
  }

  return <ProFormItem {...R.omit([ 'help', 'fieldProps' ], props)} label={`${props.label}（点击已上传的文件可以下载）`}>
    <UploadButton {...R.omit([ 'onChange' ], props)} {...props.fieldProps} />
  </ProFormItem>
}
